import { StyleSheet } from 'react-native';
import { errorRed } from '../../constants/palette';

const styles = StyleSheet.create({
  scrollViewContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  createAccount: {
    width: 250, // FIXME: THIS IS A HACK
  },
  headers: {
    padding: 10,
    width: 250, // FIXME: THIS IS A HACK
  },

  errorContainer: {
    marginTop: 10,
    marginBottom: 10,
    flex: 1,
  },
  logo: { marginBottom: 50 },
  link: {
    alignSelf: 'flex-end',
  },

  signInErrorText: {
    color: errorRed,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  signIn: {
    marginTop: 40,
    marginBottom: 75,
  },
});
export default styles;
